<template>
    <div>
        <el-table :data="tableData" tooltip-effect="dark" :stripe="true" :header-cell-style="tableHeaderCellStyle">
            <el-table-column prop="assesmentName" label="考核名称" align="center" width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="assesmentAllocation" label="考核类型" align="center">
                <template slot-scope="scope">{{ scope.row.assesmentAllocation | assesmentAllocationFilter }}</template>
            </el-table-column>
            <el-table-column prop="assesmentScore" label="考核总分" align="center"></el-table-column>
            <el-table-column prop="passingScore" label="及格分数" align="center"></el-table-column>
            <el-table-column prop="learnTopics.length" label="题目数量" align="center"></el-table-column>
            <el-table-column prop="sysUser.nickName" label="管理者" align="center"></el-table-column>
            <el-table-column width="180" prop="assesmentStartTime" label="开始时间" align="center"></el-table-column>
            <el-table-column width="180" prop="assesmentEndTime" label="结束时间" align="center"></el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleEdit(scope.$index, scope.row)">进入考核</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="mb-pagination"
            @current-change="handleCurrentChange"
            :current-page="curPage"
            layout="total, prev, pager, next"
            :total="total">
        </el-pagination>
    </div>
</template>

<script>
    import CommonStyle from "@/utils/CommonStyle";
    export default {
        name: "StudentAssessment",
        data() {
            return {
                tableHeaderCellStyle: CommonStyle.tableHeaderCellStyle,
                tableData: [],
                total: 0,
                curPage: 1
            };
        },
        filters: {
            assesmentAllocationFilter(assesmentAllocation) {
                if (parseInt(assesmentAllocation) === 1) {
                    return "考试";
                } else if (parseInt(assesmentAllocation) === 2) {
                    return "课后练习";
                } else if (parseInt(assesmentAllocation) === 3) {
                    return "专项训练";
                }
            }
        },
        mounted() {
            this.assesmentList(1);
        },
        methods: {
            assesmentList(curPage) { // 考核列表
                let that = this;
                that.HttpConnection.get("/learn/assesment/list", {
                    params: {
                        pageNum: curPage,
                        pageSize: 10
                    }
                }).then(function(response) {
                    that.tableData = response.rows;
                    that.total = response.total;
                });
            },
            handleEdit(index, row) {
                if (row.assesmentedFlag) {
                    this.$message({
                        type: "error",
                        message: "当前已考核，禁止再次进入"
                    });
                } else {
                    let currentTime = new Date().getTime();
                    let startTime = new Date(row.assesmentStartTime).getTime();
                    let endTime = new Date(row.assesmentEndTime).getTime();
                    if (currentTime < startTime) {
                        this.$message({
                            type: "warning",
                            message: "当前时间未到开考时间"
                        });
                        return;
                    }
                    if (currentTime > endTime) {
                        this.$message({
                            type: "warning",
                            message: "当前时间已过开考时间"
                        });
                        return;
                    }
                    this.$router.push({
                        path: "/ManageStudy/StudentAssessmentAnswer",
                        query: {
                            assesmentId: row.assesmentId
                        }
                    });
                }
            },
            handleCurrentChange(val) {
                this.curPage = val;
                this.assesmentList(val);
            }
        }
    };
</script>

<style scoped lang="scss">

</style>
